var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45801 25.375C7.79342 25.375 7.2245 25.1384 6.75124 24.6651C6.27797 24.1918 6.04134 23.6229 6.04134 22.9583V7.25H4.83301V4.83333H10.8747V3.625H18.1247V4.83333H24.1663V7.25H22.958V22.9583C22.958 23.6229 22.7214 24.1918 22.2481 24.6651C21.7748 25.1384 21.2059 25.375 20.5413 25.375H8.45801ZM20.5413 7.25H8.45801V22.9583H20.5413V7.25ZM10.8747 20.5417H13.2913V9.66667H10.8747V20.5417ZM15.708 20.5417H18.1247V9.66667H15.708V20.5417Z",
    fill: "#06513D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9af01ada184bed66464c80e75a269b1b.svg";
export { ForwardRef as ReactComponent };